module.exports = __webpack_public_path__ + "static/singapore-fantastic-trip-5dbf8d5f1394dcb846de77913311c863.png";